import { Routes, Route, useNavigate } from 'react-router-dom'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard/Dashboard'
import SignUp from './pages/SignUp'
import { useEffect, useRef, useState } from 'react'
import { _setSelectedCompanyId, company, customerData, IDMEVerification } from './utilities/CustomerData'
import { apiURL, setAPIUrl } from './utilities/URLs'
import Account from './pages/Account'
import RequestPasswordReset from './pages/PasswordReset/RequestPasswordReset'
import ResetPassword from './pages/PasswordReset/ResetPassword'
import SETCStartingForm from './pages/SETCStartingForm'
import DownloadDocument from './pages/Dashboard/DashboardScreens/DownloadDocument'
import { PaymentCenter } from './pages/Payment/PaymentCenter'
import { AddPaymentMethod } from './pages/Payment/AddPaymentMethod'
import { refreshAccessToken } from './utilities/extensions'
import Page404 from './pages/404'
import NewApplication from './pages/ApplicationProcess/NewApplication'
import Maintenance from './pages/Maintenance'
import posthog from 'posthog-js'
import { ShippoRates } from './pages/Shippo/ShippoRates'
import RefundCalculated from './pages/RefundCalculated/RefundCalculated'
import BankValidationFailed from './pages/RefundCalculated/BankValidationFailed'
import AdvanceFundingApplication from './pages/RefundCalculated/AdvanceFundingApplication'
import { ESign } from './pages/RefundCalculated/ESign'
import { ShippoLabel } from './pages/Shippo/ShippoLabel'
import { NewChartConnect } from './pages/ApplicationProcess/Chart/NewChartConnect'
import TermsAndConditions from './pages/RefundCalculated/TermsAndConditions'
import GoogleTranslate from './GoogleTranslate'
import { ChartConnect } from './pages/ApplicationProcess/Chart/ChartConnect'
import { DashboardResyncIDME } from './pages/Dashboard/DashboardScreens/DashboardResyncIDME'
import { Resign } from './pages/RefundCalculated/Resign'
import SignAffidavit from './pages/RefundCalculated/SignAffidavit'
import { ReadyCloud } from './pages/ReadyCloud/ReadyCoud'
import { SyncNewBankAccount } from './pages/RefundCalculated/SyncNewBankAccount'
import SyncNewDocuments from './pages/SyncNewDocuments'
import SignTOS from './pages/SignTOS'
import SpouseCalculation from './pages/SpouseCalculation'

import NavBar from './utilities/NavBar'

import langaugeIcon from './assets/ApplicationIcons/languageIcon.png'

export default function App() {
  const navigate = useNavigate()

  const routeNames = ['dashboard', 'signUp', 'requestPasswordReset', 'resetPassword', 'account', 'paymentPortal', 'addPaymentMethod', 'newApplication', 'chartConnect', 'calculateRefund', 'shippoRates', 'setcStartingForm']

  const [fetchedCompany, setFetchedCompany] = useState(false)
  const [checkingLogin, setCheckingLogin] = useState(true)
  const [loggingInWithAccessToken, setLoggingInWithAccessToken] = useState(false)
  const [loggedIn, setLoggedIn] = useState(false)
  const [showNavBar, setShowNavBar] = useState(true)
  const [impersonationMode, setImpersonationMode] = useState(false)
  const [show404Page, setShow404Page] = useState(false)
  const [showMobileSideBar, setShowMobileSideBar] = useState(false)
  const [showGoogleTranslate, setShowGoogleTranslate] = useState(false)
  const [idmeError, setIdmeError] = useState('')

  const [checkForCalculation, setCheckForCalculation] = useState(false)
  let intervalIdRef = useRef(null)

  const [reload, setReload] = useState(false)

  useEffect(() => {
    const handleGetCompany = async () => {
      const companyResponse = await fetch(`${apiURL}/api/getCompany?companyURL=${encodeURIComponent(window.location.hostname)}`)
      const companyData = await companyResponse.json()
      if(companyData.response.error)
        console.error(companyData.response.error)
      else {
        company.setCompany(companyData.response.company)

        document.title = company.companyName

        let link = document.querySelector("link[rel~='icon']")
        if (!link) {
            link = document.createElement('link')
            link.rel = 'icon'
            document.head.appendChild(link)
        }
        link.href = company.companyFavIconURL

        let link2 = document.querySelector("link[rel~='apple-touch-icon']")
        if (!link2) {
            link2 = document.createElement('link')
            link2.rel = 'apple-touch-icon'
            document.head.appendChild(link)
        }
        link.href2 = company.companyFavIconURL
        
        document.documentElement.style.setProperty('--primary-color', company.companyPrimaryColor)
        document.documentElement.style.setProperty('--primary-dark-color', company.companyPrimaryDarkColor)
        document.documentElement.style.setProperty('--secondary-color', company.companySecondaryColor)
        document.documentElement.style.setProperty('--secondary-dark-color', company.companySecondaryDarkColor)
        _setSelectedCompanyId(company.companyId)

        setFetchedCompany(true)
      }
    }

    setAPIUrl(window.location.hostname)
    handleGetCompany()
  }, [])

  useEffect(() => {
    const handleLoginWithAccessToken = async (code = '', isSpouse = false, isResync = false, isUpload = false) => {
      setLoggingInWithAccessToken(true)

      const loginWithCustomerIdResponse = await fetch(`${apiURL}/api/loginWithJWT`, {
        headers: {
          'Authorization': accessToken,
        },
      })
      const loginWithCustomerIdData = await loginWithCustomerIdResponse.json()
      if (loginWithCustomerIdData.response.error) {
        if (loginWithCustomerIdData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          if (refreshedToken) {
            accessToken = refreshedToken
            handleLoginWithAccessToken(code, isResync, isUpload)
          } else {
            console.error(loginWithCustomerIdData.response.error)
            setLoggedIn(false)
            setLoggingInWithAccessToken(false)
            navigate('/', { state: { expired: true } })
          }
        } else {
          console.error(loginWithCustomerIdData.response.error)
          setLoggedIn(false)
          setLoggingInWithAccessToken(false)
          navigate('/', { state: { expired: true } })
        }
      } else {
        customerData.setCustomerData(loginWithCustomerIdData.response.customerAccount)
        customerData.accessToken = accessToken
        posthog.identify(customerData.customerLeadData.leadContact.contactId, {
          name: customerData.customerLeadData.leadContact.contactName,
          email: customerData.customerLeadData.leadContact.contactEmail
        })
        setLoggedIn(true)
        setLoggingInWithAccessToken(false)

        const { invoiceRate, customerVaultId } = customerData.customerInvoiceData
        if(isResync)
          customerData.customerVerificationData = new IDMEVerification({ customerId: customerData.customerLeadData.leadContact.contactId })
        if(isUpload) {
          if(customerData.customerLeadData.leadStage.leadStageId === '54f7e7f4-6f4a-4a8f-95bb-414657a89404')
            customerData.updateCustomerStage('25f7468c-f94f-4f19-aba3-8050a2661980', 'd23bdf4e-886f-493a-b628-8c9a1efb398b', 'AF - Issue Resolved')
        }
        if(code)
          navigate(`/refundCalculated?code=${code}${isSpouse ? '&isSpouse=1' : ''}`)
        else
          navigate(invoiceRate === '0.2' && customerVaultId.length === 0 ? '/addPaymentMethod' : '/dashboard')
      }
    }

    const handleLoginWithIDMECode = async (code) => {
      setLoggingInWithAccessToken(true)

      const loginIDMEResponse = await fetch(`${apiURL}/api/loginWithIDMECode?code=${encodeURIComponent(code)}&companyURL=${apiURL}`)
      const loginIDMEData = await loginIDMEResponse.json()
      if(loginIDMEData.response.error) {
        navigate('/', { state: { idme: true } })
        setLoggedIn(true)
        setLoggingInWithAccessToken(false)
      } else {
        customerData.setCustomerData(loginIDMEData.response.customerAccount)
        customerData.accessToken = accessToken
        posthog.identify(customerData.customerLeadData.leadContact.contactId, {
          name: customerData.customerLeadData.leadContact.contactName,
          email: customerData.customerLeadData.leadContact.contactEmail
        })
        setLoggedIn(true)
        setLoggingInWithAccessToken(false)

        const { invoiceRate, customerVaultId } = customerData.customerInvoiceData
        navigate(invoiceRate === '0.2' && customerVaultId.length === 0 ? '/addPaymentMethod' : '/dashboard')
      }
    }

    const handleExchangeIDMECode = async (code, isSpouse) => {
      const form = new FormData()
      form.append('codeInfo', JSON.stringify({
        customerId: customerData.customerLeadData.leadContact.contactId,
        isSpouse: isSpouse,
        code: code
      }))

      const exchangeCodeResponse = await fetch(`${apiURL}/api/exchangeCodeIDME`, {
        method: 'POST',
        body: form
      })
      const exchangeCodeData = await exchangeCodeResponse.json()
      if(exchangeCodeData.response.error) {
        if(exchangeCodeData.response.error === 'SSN is not found/not matching.')
          setIdmeError('The last 4 digits of your SSN do not match our records. Please make sure you are using the correct ID.me account linked to your SSN.')
        else
          setIdmeError('We ran into an issue retrieving your ID.me information. Please try again by clicking the button below.')

        if(exchangeCodeData.response.error === 'Expired Documents')
          navigate('/syncNewDocuments', { state: { upload: false }})
        else
          navigate('/resyncIDme', { state: { isSpouse: isSpouse }})
      }
    }

    const handleUploadIDMECode = async (code) => {
      const form = new FormData()
      form.append('codeInfo', JSON.stringify({
        customerId: customerData.customerLeadData.leadContact.contactId,
        isUpload: true,
        code: code
      }))

      const exchangeCodeResponse = await fetch(`${apiURL}/api/exchangeCodeIDME`, {
        method: 'POST',
        body: form
      })
      const exchangeCodeData = await exchangeCodeResponse.json()
      if(exchangeCodeData.response.error) {
        if(exchangeCodeData.response.error === 'SSN is not found/not matching.')
          setIdmeError('The last 4 digits of your SSN do not match our records. Please make sure you are using the correct ID.me account linked to your SSN.')
        else
          setIdmeError('We ran into an issue retrieving your ID.me information. Please try again by clicking the button below.')

        if(exchangeCodeData.response.error === 'Expired Documents')
          navigate('/syncNewDocuments', { state: { upload: true }})
        else
          navigate('/resyncIDme')
      }
    }

    const handleResyncIDME = async (code, isSpouse) => {
      await handleLoginWithAccessToken('', false, true, false)
      while (!customerData?.customerLeadData.leadContact.contactId)
        await new Promise(resolve => setTimeout(resolve, 100))

      await handleExchangeIDMECode(code, isSpouse)
    }

    const handleUploadIDME = async (code) => {
      await handleLoginWithAccessToken('', false, true, true)
      while (!customerData?.customerLeadData.leadContact.contactId)
        await new Promise(resolve => setTimeout(resolve, 100))
    
      await handleUploadIDMECode(code)
    }

    const handleImpersonateCustomer = async (customerId) => {
      const impersonateCustomerResponse = await fetch(`${apiURL}/api/impersonateCustomer?customerId=${encodeURIComponent(customerId)}`)
      const impersonateCustomerData = await impersonateCustomerResponse.json()

      if (impersonateCustomerData.response.error) {
        console.error(impersonateCustomerData.response.error)
        if(accessToken)
          await handleLoginWithAccessToken()
        else
          return setShow404Page(true)
      }
      customerData.setCustomerData(impersonateCustomerData.response.customerAccount)
      customerData.accessToken = impersonateCustomerData.response.accessToken
      customerData.impersonationMode = true
      setImpersonationMode(true)
      setLoggedIn(true)
      setLoggingInWithAccessToken(false)
      navigate('/dashboard')
    }

    const handleNavigation = (parts) => {
      const gclid = urlSearchParams.get('gclid') ?? ''

      switch (parts[1]) {
        case 'termsAndConditions':
          navigate('/termsAndConditions')
          break
        case 'idme':
          const hasSpouse = localStorage.getItem('idmeSpouse')
          localStorage.removeItem('idme')
          localStorage.removeItem('idmeSpouse')
          const state = urlSearchParams.get('state')
          if(state) {
            if(state === 'login')
              handleLoginWithIDMECode(urlSearchParams.get('code'))
            else if(state === 'resync')
              handleResyncIDME(urlSearchParams.get('code'), hasSpouse ? true : false)
            else if(state === 'upload')
              handleUploadIDME(urlSearchParams.get('code'))
            else if(state === 'spouse')
              handleLoginWithAccessToken(urlSearchParams.get('code'), true)
            else
              navigate(`/chartConnect/${state}?code=${urlSearchParams.get('code')}`)
          } else
            handleLoginWithAccessToken(urlSearchParams.get('code'))
          break
        case 'resetPassword':
          navigate(`/resetPassword/${parts[2]}`)
          break
        case 'notQualified':
        case 'preQualified':
          localStorage.setItem('customerAccessToken', parts[2])
          window.location.href = parts[1] === 'notQualified' ? apiURL : `${apiURL}/chartConnect/${parts[3]}${gclid && `?gclid=${gclid}`}`
          break
        case 'setcStartingForm':
          case 'newApplication':
            const companyId = urlSearchParams.get('companyId') ?? '6243c824-9e29-46da-94c6-96d03d8cbb84'
            const params = new URLSearchParams({ companyId })
            const optionalParams = ['gclid', 'clickid', 'fclid', 'sub1', 'sub2', 'sub3', 'sub4', 'sub5', 'utm_source', 'utm_medium', 'utm_campaign']
            optionalParams.forEach(param => {
                const value = urlSearchParams.get(param)
                if (value) params.append(param, value)
            })
            const path = `/${parts[1]}/${parts[1] === 'newApplication' ? (parts[2] || 'Website Home') : ''}`
            navigate(`${path}?${params.toString()}`)
            setShowNavBar(false)
            break       
        case 'chartConnect':
          navigate(`/chartConnect/${parts[2]}${gclid && `?gclid=${gclid}`}`)
          break
        default:
          if (!routeNames.includes(parts[1])) {
            setLoggingInWithAccessToken(true)
            handleImpersonateCustomer(parts[1])
          } else {
            if (accessToken) {
              setLoggingInWithAccessToken(true)
              handleLoginWithAccessToken()
              navigate(`/${parts[1]}`)
            }
          }
          break
      }
    }

    const url = window.location.pathname
    const parts = url.split('/')
    let accessToken = localStorage.getItem('customerAccessToken')
    const urlSearchParams = new URLSearchParams(window.location.search)

    if(reload || fetchedCompany) {
      setCheckingLogin(true)
      if (parts.length > 1 && parts[1])
        handleNavigation(parts)
      else {
        if (accessToken)
          handleLoginWithAccessToken()
      }

      setCheckingLogin(false)
    }
  }, [reload, fetchedCompany])

  const handleCheckCalculation = async (callCount) => {
    const checkCalcResponse = await fetch(`${apiURL}/api/checkForCalculation?contactId=${encodeURIComponent(customerData.customerLeadData.leadContact.contactId)}`, {
      headers: {
        'Authorization': customerData.accessToken
      }
    })
    const checkCalcData = await checkCalcResponse.json()
    if(checkCalcData.response.error) {
      if(checkCalcData.response.error === 'Failed To Authenticate Token.') {
        const refreshedToken = await refreshAccessToken()
        refreshedToken && refreshedToken.length > 0 ? await handleCheckCalculation() : navigate('/', { state: { expired: true } })
      }
    } else {
      if(checkCalcData.response.calculated === true)
        window.location.reload()
    }

    if(callCount >= 5)
      clearInterval(intervalIdRef.current)
  }

  useEffect(() => {
  let callCount = 0
  
  if (checkForCalculation) {
    intervalIdRef = setInterval(async () => {
      if (callCount < 5) {
        callCount++
        await handleCheckCalculation(callCount)
      } else
        clearInterval(intervalIdRef.current)
    }, 30000)

    return () => clearInterval(intervalIdRef.current)
  }
}, [checkForCalculation])

  if(!fetchedCompany)
    return null

  if (checkingLogin)
    return null

  return (
    <>
      {show404Page ? (
        <Page404 />
      ) : (
        loggingInWithAccessToken ? (
          <div className='flex flex-col items-center justify-center h-screen font-mont'>
            <img className='w-60 mb-28' src={company.companyLogoURL} alt='setcLogo' />
            <div className="loader ease-linear rounded-full border-8 border-t-8 h-12 w-12 mb-4"></div>
            <p className='text-xl'>Logging In...</p>
          </div>
        ) : (
          <>
            {(loggedIn && showNavBar) && (
              <NavBar impersonationMode={impersonationMode} setShowMobileSideBar={setShowMobileSideBar} />
            )}
            <Routes>
              <Route path='/' element={<Login setLoggedIn={setLoggedIn} setShowNavBar={setShowNavBar} />} />
              <Route path='/dashboard' element={<Dashboard showMobileSideBar={showMobileSideBar} setShowMobileSideBar={setShowMobileSideBar} setShowNavBar={setShowNavBar} setCheckForCalculation={setCheckForCalculation} />} />
              <Route path='/signUp/:token' element={<SignUp setLoggedIn={setLoggedIn} />} />
              <Route path='/requestPasswordReset' element={<RequestPasswordReset />} />
              <Route path='/resetPassword/:token' element={<ResetPassword />} />
              <Route path='/account' element={<Account setShowNavBar={setShowNavBar} />} />
              <Route path='/downloadDocument' element={<DownloadDocument />} />
              <Route path='/paymentPortal' element={<PaymentCenter />} />
              <Route path='/addPaymentMethod' element={<AddPaymentMethod setShowNavBar={setShowNavBar} />} />
              <Route path='/newApplication/:leadSource' element={<NewApplication />} />
              <Route path='/chartConnect/:contactId' element={<ChartConnect setReload={setReload} />} />
              <Route path='/shippoRates' element={<ShippoRates />} />
              <Route path='/refundCalculated' element={<RefundCalculated setReload={setReload} />} />
              <Route path='/setcStartingForm' element={<SETCStartingForm />} />
              <Route path='/bankvalidation' element={<BankValidationFailed />} />
              <Route path='/advanceFundingApplication' element={<AdvanceFundingApplication />} />
              <Route path='/esign' element={<ESign />} />
              <Route path='/shippoLabel' element={<ShippoLabel />} />
              <Route path='/readyCloud' element={<ReadyCloud />} />
              <Route path='/newChartConnect/:contactId' element={<NewChartConnect setReload={setReload} />} />
              <Route path='/termsAndConditions' element={<TermsAndConditions />} />
              <Route path='/resyncIDme' element={<DashboardResyncIDME isPage={true} idmeError={idmeError} />} />
              <Route path='/resign' element={<Resign />} />
              <Route path='/signAffidavit' element={<SignAffidavit />} />
              <Route path='/syncNewBankAccount' element={<SyncNewBankAccount />} />
              <Route path='/syncNewDocuments' element={<SyncNewDocuments isPage={true} />} />
              <Route path='/signTOS' element={<SignTOS />} />
              <Route path='/spouseCalculation' element={<SpouseCalculation setReload={setReload} />} />
            </Routes>
            <div className='fixed max-sm:right-0 right-5 bottom-5 max-sm:bottom-0 bg-gray-300 p-4 rounded-lg shadow-lg max-sm:scale-80 z-10'>
              {!showGoogleTranslate ? (
                <button
                  className='bg-blue-500 text-white px-4 py-2 rounded-lg shadow-md hover:bg-blue-600'
                  onClick={() => setShowGoogleTranslate(true)}
                >
                  <img className='w-8 h-8' src={langaugeIcon} />
                </button>
              ) : (
                <div className='flex flex-col items-end'>
                  <button
                    onClick={() => setShowGoogleTranslate(false)}
                    className='fixed right-5 bottom-5 text-red-500 hover:text-red-700 transition-colors duration-200'>
                    <svg xmlns='http://www.w3.org/2000/svg' className='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
                      <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M6 18L18 6M6 6l12 12' />
                    </svg>
                  </button>
                  <GoogleTranslate />
                </div>
              )}
            </div>
          </>
        )
      )}
    </>
  )

  /*return (
    <Maintenance />
  )*/
}